/**
 * Forms class - třída s funkcemi pro formuláře
 */
var Forms = window.Forms = function () {
    this.defaultFormSended = false;
    this.formSend = false;
}

Forms.prototype.init = function () {
    if ($('#frm-offerForm-znacka').length > 0) {
        window.forms.initZnackaSelect('offerForm', 'ohodnoceni');
    }

    if ($('#frm-requestForm-znacka').length > 0) {
        window.forms.initZnackaSelect('requestForm', 'request');
    }

    if ($('#frm-carTargetForm-znacka').length > 0) {
        window.forms.initZnackaSelect('carTargetForm', 'carTarget');
    }

    if ($('#frm-companyForm2-pocet').length > 0) {
        window.forms.initCarsCount2();
    } else if ($('#frm-companyForm-pocet').length > 0) {
        window.forms.initCarsCount();
    }

    if ($('#frm-contactAsForm-znacka').length > 0) {
        window.forms.initZnackaSelect('contactAsForm', 'contactAs');
    }

    if ($('#frm-vipOfferForm-znacka').length > 0) {
        window.forms.initZnackaSelect('vipOfferForm', 'vipVykup');
    }

    this.initShowRulesModal();
    this.initCalcToReserve();
    this.initDiscountToReserve();
    this.initChangeToReserve();
}

Forms.prototype.reload = function () {

}

Forms.prototype.initZnackaSelect = function (formName, action) {
    var url = '/formular/' + action;
    if (action === 'contactAs') {
        url = '/kontakty/napiste-nam';
    }
    if (action === 'carTarget') {
        url = '/prodej/car-target';
        // url = '/prodej';
    }
    if (action === 'vipVykup') {
        url = '/formular/vip-vykup';
    }
    $('#frm-' + formName + '-znacka').on('change', function () {
        $.nette.ajax({
            type: 'GET',
            url: url + '?do=changeModels',
            data: {
                'value': $(this).val(),
                'form': formName,
            }
        }).done(function () {
            $('#frm-' + formName + '-model').select2();
            if (formName === 'vipOfferForm') {
                $('#frm-vipOfferForm-model').closest('.styled-select').removeClass('slate');
                $('#frm-vipOfferForm-model').select2();
            }
        });
    });
}

Forms.prototype.initCarsCount = function () {
    $('#frm-companyForm-pocet').on('change', function () {
        var count = $(this).val();
        if (count > -1) {
            $.nette.ajax({
                type: 'GET',
                url: '/formular/company',
                data: {
                    'count': count,
                }
            });
        }
    });
}

Forms.prototype.initCarsCount2 = function () {
    $('#frm-companyForm2-pocet').on('change', function () {
        var count = $(this).val();
        if (count > -1) {
            $.nette.ajax({
                type: 'GET',
                url: window.location.href,
                data: {
                    'count': count,
                }
            });
        }
    });
}

Forms.prototype.initDiscountToReserve = function () {
    var self = this;
    var elBtn = $('form .initDiscountToReserve');
    elBtn.closest('form').find('input').keypress(function (e) {
        if (e.which == 13) {
            self.discountToReserve($(this).closest('form').find('.initDiscountToReserve').get(0));
            return false;
        }
    });

    elBtn.on('click', function () {
        self.discountToReserve(this);
    });
}

Forms.prototype.discountToReserve = function (elBtn) {
    var self = this;

    var elForm = elBtn.closest('form');

    if (!Nette.validateForm(elForm)) {
        return;
    }

    elForm = $(elForm);
    elBtn = $(elBtn);

    var agree = elForm.find('input[name=agree]').prop('checked');
    var reservationModal = elForm.find('#reservationModal');

    if (reservationModal.length) {
        $(reservationModal).modal('show');

        $(reservationModal).on('hide.bs.modal', function () {
            self.sendDefaultForm(elBtn, agree);
        });

        $(window).on('beforeunload', function () {
            self.sendDefaultForm(elBtn, agree);
        });

        $('.btn-no-reserve').off('click').on('click', function () {
            self.sendDefaultForm(elBtn, agree);
        });

        $('.btn-reserve').off('click').on('click', function () {
            self.sendReservationFromDiscountForm(elBtn, agree);
        });

    } else {
        self.sendDefaultForm(elBtn, agree);
    }
};

Forms.prototype.initCalcToReserve = function () {
    var self = this;
    var elBtn = $('form .initCalcToReserve');
    elBtn.closest('form').find('input').keypress(function (e) {
        if (e.which == 13) {
            self.calcToReserve($(this).closest('form').find('.initCalcToReserve').get(0));
            return false;
        }
    });

    elBtn.on('click', function () {
        self.calcToReserve(this);
    });
}

Forms.prototype.calcToReserve = function (elBtn) {
    var self = this;

    var elForm = elBtn.closest('form');

    if (!Nette.validateForm(elForm)) {
        return;
    }

    elForm = $(elForm);
    elBtn = $(elBtn);

    var agree = elForm.find('input[name=agree]').prop('checked');
    var reservationModal = elForm.find('#reservationModal');

    if (reservationModal.length) {
        $(reservationModal).modal('show');

        $(reservationModal).on('hide.bs.modal', function () {
            self.sendDefaultForm(elBtn, agree);
        });

        $(window).on('beforeunload', function () {
            self.sendDefaultForm(elBtn, agree);
        });

        $('.btn-no-reserve').off('click').on('click', function () {
            self.sendDefaultForm(elBtn, agree);
        });

        $('.btn-reserve').off('click').on('click', function () {
            self.sendReservationFromCalcForm(elBtn, agree);
        });

    } else {
        self.sendDefaultForm(elBtn, agree);
    }
};

Forms.prototype.initShowRulesModal = function () {
    var self = this;
    $('form .showRulesModal').on('click', function () {
        if (Nette.validateForm(this)) {
            $(this).closest('form').find('#agreeModal').modal('show');

            $(this).closest('form').find('.btn-agree').off('click').on('click', function () {
                self.sendFormRulesModal($(this), '1');
            });
            $(this).closest('form').find('.btn-no-agree').off('click').on('click', function () {
                self.sendFormRulesModal($(this), '0');
            });
            $(this).closest('form').find('#agreeModal').on('hide.bs.modal', function () {
                self.sendFormRulesModal($(this).find('.btn-no-agree'), '0');
            });
        }
    });
}

Forms.prototype.sendFormRulesModal = function (elBtn, agree) {
    var self = this;

    if (self.formSend) {
        return;
    }

    var reservationModal = elBtn.closest('form').find('#reservationModal');
    if (reservationModal.length) {
        elBtn.closest('form').find('#agreeModal').modal('hide');
        $(reservationModal).modal('show');

        $(reservationModal).on('hide.bs.modal', function () {
            self.sendDefaultForm(elBtn, agree);
        });

        $(window).on('beforeunload', function () {
            self.sendDefaultForm(elBtn, agree);
        });

        $('.btn-no-reserve').off('click').on('click', function () {
            self.sendDefaultForm(elBtn, agree);
        });

        $('.btn-reserve').off('click').on('click', function () {
            self.sendReservationFromCalcForm(elBtn, agree);
        });

    } else {
        self.sendDefaultForm(elBtn, agree);
    }
}

// checkbox se do POSTu dostane jen kdyz je checked - .val() na nem nic nezmeni.
// Pozor i na retezec '0', ktery je v JS truthy (prichazi z agreeModalu).
Forms.prototype.isAgreed = function (agree) {
    return agree === true || agree === 1 || agree === '1';
};

Forms.prototype.sendDefaultForm = function (elBtn, agree) {
    if (!this.formSend) {
        this.formSend = true;
        elBtn.closest('form').find('input[name=agree]').prop('checked', this.isAgreed(agree));
        elBtn.closest('form').find('button[type=submit]').trigger('click');
    }
};

Forms.prototype.sendReservationFromCalcForm = function (elBtn, agree) {
    if (this.formSend) {
        return false;
    }
    this.formSend = true;
    $('#frm-bookingForm-name').val($('#frm-calcForm-name').val());
    $('#frm-bookingForm-mail').val($('#frm-calcForm-mail').val());
    $('#frm-bookingForm-prefix').val($('#frm-calcForm-prefix').val());
    $('#frm-bookingForm-phone').val($('#frm-calcForm-phone').val());
    $('#frm-bookingForm-agree').prop('checked', this.isAgreed(agree));
    $('#changeFromCalc').val('1');
    $('#frm-bookingForm').find('button[type=submit]').trigger('click');
};

Forms.prototype.sendReservationFromDiscountForm = function (elBtn, agree) {
    if (this.formSend) {
        return false;
    }

    this.formSend = true;
    $('#frm-bookingForm-name').val($('#frm-discountForm-name').val());
    $('#frm-bookingForm-mail').val($('#frm-discountForm-mail').val());
    $('#frm-bookingForm-prefix').val($('#frm-discountForm-prefix').val());
    $('#frm-bookingForm-phone').val($('#frm-discountForm-phone').val());
    $('#frm-bookingForm-agree').prop('checked', this.isAgreed(agree));
    $('#changeFromDiscount').val('1');
    $('#frm-bookingForm').find('button[type=submit]').trigger('click');
}


Forms.prototype.initChangeToReserve = function () {
    var self = this;
    $('form .initChangeToReserve').on('click', function () {
        var elBtn = $(this);
        var elForm = $(this).closest('form');
        if (Nette.validateForm(this)) {
            var reservationModal = elForm.find('#reservationModal');

            if (reservationModal.length) {
                $(reservationModal).modal('show');

                $(reservationModal).on('hide.bs.modal', function () {
                    self.sendDefaultForm(elBtn);
                });

                $(window).on('beforeunload', function () {
                    self.sendDefaultForm(elBtn);
                });

                $('.btn-no-reserve').off('click').on('click', function () {
                    self.sendDefaultForm(elBtn);
                });

                $('.btn-reserve').off('click').on('click', function () {
                    elForm.find('input[name=changeToReserve]').val('1')
                    self.sendDefaultForm(elBtn);
                });

            } else {
                self.sendDefaultForm(elBtn);
            }
        }
    });
};